/**
 * Chat API base URL from apiEndpoints.js (per-environment, no GitLab env vars needed).
 */
import API_ENDPOINTS from '../../apiEndpoints';

const CHAT_API_BASE_URL = API_ENDPOINTS.CHAT_API_URL || 'http://localhost:8000/chatbot';

/** Get Cognito access token from localStorage for chat API/WS auth */
export function getChatAccessToken(): string | null {
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key && key.startsWith('CognitoIdentityServiceProvider') && key.endsWith('.accessToken')) {
        return localStorage.getItem(key)
      }
    }
  } catch (e) {
    console.error('[ChatBot] Error getting access token:', e)
  }
  return null
}

/**
 * WebSocket URL for chat: same host as API, path /chat/ws (under /chatbot prefix).
 */
export function getChatWsUrl(): string {
  const base = CHAT_API_BASE_URL;
  const wsProtocol = base.startsWith('https') ? 'wss' : 'ws';
  const host = base.replace(/^https?:\/\//, '');
  return `${wsProtocol}://${host}/chat/ws`;
}

export const CHAT_API_BASE_URL_READ = CHAT_API_BASE_URL;
